import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
const WEBHOOK_URL = 'https://services.leadconnectorhq.com/hooks/mmuChs2XqH3KvF4a7fk2/webhook-trigger/f07449ae-fa29-4633-b702-bd3257d6fdd8';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    const formData = new FormData(e.currentTarget);
    const data: Record<string, string> = {};
    formData.forEach((value, key) => {
      if (typeof value === 'string') data[key] = value;
    });
    // Send to webhook via query params (bypasses all CORS restrictions)
    try {
      const params = new URLSearchParams(data);
      const img = new Image();
      img.src = `${WEBHOOK_URL}?${params.toString()}`;
      setIsSubmitting(false);
      setIsSuccess(true);
    } catch (err) {
      setIsSubmitting(false);
      setError('Something went wrong. Please try again.');
    }
  };
  return <div className="w-full pt-20 pb-24 bg-engage-black min-h-screen" data-id="element-801" data-mp="1e78r61wkyi57">
      <div className="max-w-5xl mx-auto px-4" data-id="element-802" data-mp="1j6tz31tqa0u2">
        {/* Hero */}
        <div className="text-center mb-16 pt-20" data-id="element-803" data-mp="1j6233pw7y139">
          <h1 className="text-5xl md:text-6xl font-black text-engage-white mb-6 tracking-tight" data-id="element-804" data-mp="mh2sw5c2qp8f">
            Contact Us
          </h1>
          <p className="text-xl text-engage-yellow font-medium" data-id="element-805" data-mp="qixwjghh9epd">
            How can we help?
          </p>
        </div>

        {/* Form Card */}
        <Card className="!p-8 md:!p-12" data-id="element-806" data-mp="10gc6cx8wb58p">
          {isSuccess ? <div className="text-center py-16" data-id="element-807" data-mp="10hn9qvyfiaza">
              <div className="w-20 h-20 bg-engage-yellow/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-808" data-mp="26wxtcil10o8e">
                <svg className="w-10 h-10 text-engage-yellow" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-809" data-mp="2bu7omev3ju45">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-810" data-mp="1h7ha1l9g003i" />
                </svg>
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-811" data-mp="13gvnnmks580v">Request Received</h2>
              <p className="text-engage-gray4 text-lg mb-8" data-id="element-812" data-mp="13erkj6upgd1n">
                Thank you for reaching out. Our growth team will review your
                information and get back to you within 24 hours to schedule your
                strategy session.
              </p>
              <Button onClick={() => setIsSuccess(false)} variant="secondary" data-id="element-813" data-mp="18f6wpv393ei1">
                Submit Another Request
              </Button>
            </div> : <form onSubmit={handleSubmit} className="space-y-8" data-id="element-814" data-mp="frt8cldmbr9j">
              {error && <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4 text-red-400 text-center" data-id="element-815" data-mp="2re4tuhwu4g8y">
                  {error}
                </div>}

              {/* Name Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-816" data-mp="2hh8hg13tf9z4">
                <Input label="First Name" name="firstName" placeholder="John" data-id="element-817" data-mp="2mfjs2e1xpoie" />
                <Input label="Last Name" name="lastName" placeholder="Doe" data-id="element-818" data-mp="2mdh5k3zzqdif" />
              </div>

              {/* Contact Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-819" data-mp="3f3z3yrprrqpi">
                <Input label="Email Address" name="email" type="email" placeholder="john@company.com" data-id="element-820" data-mp="3f24rm1skd6x1" />
                <Input label="Phone Number" name="phone" type="tel" placeholder="+1 (555) 000-0000" data-id="element-821" data-mp="3584hflifdbhg" />
              </div>

              {/* Company Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-822" data-mp="29yj35y6opccd">
                <Input label="Company Name" name="companyName" placeholder="Acme Corp" data-id="element-823" data-mp="29zu13hdg7pvk" />
                <Input label="Website URL" name="websiteUrl" type="url" placeholder="https://company.com" data-id="element-824" data-mp="208ze2asdom92" />
              </div>

              {/* Dropdowns Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-825" data-mp="2ny1vpin0if3k">
                <Input label="Industry" name="industry" as="select" options={[{
              value: 'ecommerce',
              label: 'E-commerce'
            }, {
              value: 'local_service',
              label: 'Local Services'
            }, {
              value: 'b2b',
              label: 'B2B / SaaS'
            }, {
              value: 'finance',
              label: 'Financial Services'
            }, {
              value: 'health',
              label: 'Health & Wellness'
            }, {
              value: 'other',
              label: 'Other'
            }]} data-id="element-826" data-mp="2nvpghd8n2iu7" />
                <Input label="Monthly Marketing Budget" name="monthlyBudget" as="select" options={[{
              value: '2k-5k',
              label: '$2,000 - $5,000'
            }, {
              value: '5k-10k',
              label: '$5,000 - $10,000'
            }, {
              value: '10k-20k',
              label: '$10,000 - $20,000'
            }, {
              value: '20k+',
              label: '$20,000+'
            }]} data-id="element-827" data-mp="6o5vk82b31pv" />
              </div>

              <Input label="How did you hear about us?" name="howDidYouHear" as="select" options={[{
            value: 'social',
            label: 'Social Media'
          }, {
            value: 'referral',
            label: 'Referral / Word of Mouth'
          }, {
            value: 'website',
            label: 'Website'
          }, {
            value: 'google',
            label: 'Google'
          }, {
            value: 'other',
            label: 'Other'
          }]} data-id="element-828" data-mp="3ouauuvauwwzg" />

              {/* Textarea */}
              <Input label="What marketing are you currently doing?" name="currentMarketing" as="textarea" placeholder="Tell us about your current channels, challenges, and goals..." data-id="element-829" data-mp="19x5vajjs1b6l" />

              {/* Submit */}
              <Button type="submit" variant="primary" fullWidth className="text-lg py-4 mt-8" disabled={isSubmitting} data-id="element-830" data-mp="m8cx0gfomr8t">
                {isSubmitting ? 'Submitting...' : 'Book a Call With Us'}
              </Button>
            </form>}
        </Card>
      </div>
    </div>;
}